// extracted by mini-css-extract-plugin
export var container = "_15-0";
export var disabled = "_15-4";
export var fullWidth = "_15-3";
export var lined = "_15-1";
export var selected = "_15-5";
export var tab = "_15-2";